/** Import language modules */

import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";

import HttpApi from "i18next-http-backend";

import {
  SUPPORTED_UI_LANGS,
  getLocaleFromDomain,
  getSupportedLanguage
} from "./LanguageConfig";

/** Query detector keeps explicit language selection ahead of domain and cookie. */

const queryDetector = {
  name: "query",

  lookup() {
    const language = new URLSearchParams(window.location.search).get("lang");

    return getSupportedLanguage(language);
  },

  cacheUserLanguage() {}
};

/** Custom domain detector for i18next */

const domainDetector = {
  name: "domain",

  lookup() {
    return getLocaleFromDomain(window.location.hostname);
  },

  cacheUserLanguage() {
    // Domain-based locale should not be cached as it's determined by domain
  },
};

/** Initialize languages */

const Languages = () => {
  /** Create language detector instance and add custom domain detector */

  const languageDetector = new LanguageDetector();

  languageDetector.addDetector(queryDetector);

  languageDetector.addDetector(domainDetector);

  i18n
    .use(initReactI18next)
    .use(languageDetector)
    .use(HttpApi)
    .init({
      supportedLngs: SUPPORTED_UI_LANGS,

      fallbackLng: "en",

      detection: {
        order: [
          "query",
          "domain",
          "cookie",
          "localStorage",
          "htmlTag",
          "path",
          "subdomain",
        ],

        caches: ["cookie"],
      },

      backend: { loadPath: "/i18n/locales/{{lng}}/translation.json" },

      react: { useSuspense: false },
    });
};

export { SUPPORTED_UI_LANGS };

export default Languages;
